export const tripExpenseReducerSelector = state => state.tripExpenseReducer;

export const tripExpenseDetailsSelector = state => state.tripExpenseReducer.tripExpense;
